// @flow

import { observer } from "mobx-react";
import React from "react";
import { DraggableCore } from "react-draggable";

import DragHelper from "app/util/DragHelper";
import type { DraggableData } from "app/util/DragHelper";

import "./VideoProgressRangeArrow.scss";

type Props = {
    time: number,
    duration: number,
    direction: string,
    onUpdateTime: Function,
    onDragStop: Function
};

@observer
export default class VideoProgressRangeArrow extends React.Component<Props> {
    dragStartTime: number;
    dragStartX: number;

    refs: {
        container: HTMLElement,
        wrapper: HTMLElement
    };

    handleDragStart(event: Event, data: DraggableData) {
        this.dragStartTime = this.props.time;
        this.dragStartX = data.x;
    }

    handleDrag(event: Event, data: DraggableData) {
        const time = DragHelper.positionToTime(
            this.refs.container,
            this.dragStartTime,
            this.dragStartX,
            data.x,
            this.props.duration
        );
        this.props.onUpdateTime(time);
    }

    render() {
        const time = this.props.time;
        const duration = this.props.duration;

        const style = {
            left: (time * 100) / duration + "%"
        };

        const classes = [
            "VideoProgressRangeArrow",
            "VideoProgressRangeArrow--" + this.props.direction
        ];

        return (
            <div className={classes.join(" ")} ref="container">
                <DraggableCore
                    onStart={this.handleDragStart.bind(this)}
                    onDrag={this.handleDrag.bind(this)}
                    onStop={this.props.onDragStop}
                >
                    <div
                        ref="wrapper"
                        className="VideoProgressRangeArrow-wrapper"
                        style={style}
                    >
                        <div className="VideoProgressRangeArrow-arrow">
                            <i
                                className={
                                    "fa fa-caret-" + this.props.direction
                                }
                            />
                        </div>
                    </div>
                </DraggableCore>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/components/VideoProgressRangeArrow/VideoProgressRangeArrow.js